module.exports = __webpack_public_path__ + "img/calendar-8.4fd0eccd.svg";